import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import CheckboxGroup from '../../../exportacion_react_pdf/CheckboxGroup';
import QuestionResponse from '../../../exportacion_react_pdf/QuestionResponse';
import TextAreaLabel from '../../../exportacion_react_pdf/TextAreaLabel';
import SelectGroup from '../../../exportacion_react_pdf/SelectGroup';
import TablaCalificacion from '../../../exportacion_react_pdf/TablaCalificacion';
import TextAreaLabelGroup from '../../../exportacion_react_pdf/TextAreaLabelGroup';

const secciones_socio_empresarial = [
    {
        key: "1",
        title: "ASOCIATIVA ",
        questions: [
            {
                section: "1.1",
                description: "Productor/a vinculado en programas de fortalecimiento del tejido social",
            },
        ],
    },
    {
        key: "2",
        title: "2. FINANCIERA",
        questions: [
            {
                section: "2.1",
                description: "Productor/a reconoce la importancia de manejar temas financieros y contables",
            },
            {
                section: "2.2",
                description: "Productor/a conoce e identifica las condiciones del crédito agropecuario",
            },
            {
                section: "2.3",
                description: "Productor/a participa en programas de inclusión financiera",
            },
        ],
    },
    {
        key: "3",
        title: "3. COMERCIAL",
        questions: [
            {
                section: "3.1",
                description: "Productor/a participa en eventos de promoción, ferias, mercados campesinos, etc",
            },
            {
                section: "3.2",
                description: "Productor/a conoce normas de calidad y parámetros de marca",
            },
            {
                section: "3.3",
                description: "Productor/a apropiado de su plan de negocios",
            },
            {
                section: "3.4",
                description: "Productor/a identifica los eslabones de la cadena productiva para el desarrollo de valor agregado",
            },
            {
                section: "3.5",
                description: "Productor/a capacitado en temas referidos al establecimiento de alianzas comerciales",
            },
        ],
    },
    {
        key: "4",
        title: "4. TICS",
        questions: [
            {
                section: "4.1",
                description: "Productor/a maneja herramientas ofimáticas básicas",
            },
        ],
    },
];

// Define el documento
const ExportPaso4 = ({ formData, styles }) => {
    return (
        <>
            {/* Sección de Identificació del proyecto */}
            <View style={styles.section}>

                <Text style={styles.title_1}>SOCIO-EMPRESARIAL</Text>


                <QuestionResponse
                    label={'¿Se han identificado socios claves en el territorio?'}
                    value={formData?.socios_claves || ''}>
                </QuestionResponse>

                {formData?.socios_claves === 'Otro' && (

                    <QuestionResponse
                        label={'Especifique otro socio clave'}
                        value={formData?.otra_socio_clave || ''}>
                    </QuestionResponse>
                )}

                <SelectGroup
                    label='¿Qué riesgos ha identificado en el desarrollo de su negocio?'
                    selectedValue={formData?.riesgos_desarrollo_negocio || ''}>
                </SelectGroup>


                {formData?.riesgos_desarrollo_negocio?.includes('Otro') && (
                    <QuestionResponse
                        label={'Especifique otro riesgo'}
                        value={formData?.otro_riesgos_desarrollo_negocio || ''}>
                    </QuestionResponse>
                )}



                <CheckboxGroup
                    label='¿Existen otras fuentes de ingreso diferentes al proyecto productivo?'
                    selectedValue={formData?.otras_fuentes_ingreso || ''}>
                </CheckboxGroup>

                {formData?.otras_fuentes_ingreso === 'Sí' && (

                    <TextAreaLabel
                        label={'¿Cuáles son?'}
                        value={formData?.cuales_fuentes_ingreso || ''}>
                    </TextAreaLabel>
                )}

                <CheckboxGroup
                    label='¿Han tenido acceso a recursos, apoyos o alianzas específicas para mujeres, personas jóvenes, población étnica y/o en condición de discapacidad?'
                    selectedValue={formData?.acceso_recursos || ''}>
                </CheckboxGroup>

                {formData?.acceso_recursos === 'Sí' && (

                    <TextAreaLabel
                        label={'¿Cuáles? (ej. programas para mujeres emprendedoras, apoyos para personas con discapacidad)'}
                        value={formData?.cuales_acceso_recursos || ''}>
                    </TextAreaLabel>
                )}

                <Text style={styles.title_1}>CAPACIDADES SOCIO-EMPRESARIAL</Text>

                <TablaCalificacion evaluacion={formData?.capacidades_socio_empresarial} secciones={secciones_socio_empresarial}></TablaCalificacion>
            </View>
        </>
    )

};

export default ExportPaso4;